<template>
      <v-container class="py-5 px-5" fluid v-if="this.$store.state.signedIn">
        <v-layout justify-center wrap>
            <v-flex xs12 md8 class="py-2 px-2">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title :style="$store.state.textFormatting.headers"> Users for {{this.$store.state.user.organisation}} </v-toolbar-title>
                    <v-progress-circular v-if="loading" indeterminate color="white"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <v-btn @click="addUserOpen" color="success" :style="$store.state.textFormatting.main">ADD USER <v-icon>add</v-icon></v-btn>
                    <info>
                        <template slot>
                            Organisation Admin
                        </template>
                        <template slot="body">
                            <p>Add users with the 'Add User' button</p>
                            
                            <b> NOTE: Users will NOT appear in this list until they have confirmed sign up via the verification email sent to their email address</b>
                            <br />
                            <p>Edit, delete or change the password of current users with the icons in the table</p>
                            
                        </template>
                    </info>
                </v-toolbar>
                <v-card>
                    <v-data-table :headers="headersForUsersTable" :items="UsersInTableForGroup" :key="id"
                            :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination">
                    <template slot="headerCell" slot-scope="props">
                        <v-tooltip top eager>
                        <span slot="activator" :style="$store.state.textFormatting.main">
                            {{ props.header.text }}
                        </span>
                        <span :style="$store.state.textFormatting.main">
                            {{ props.header.ad_text }}
                        </span>
                        </v-tooltip>
                    </template> 
                    <template slot="items" slot-scope="props">
                        <tr>
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{props.item.username}} </td>
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{props.item.email}} </td>
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{props.item.given_name}} </td>
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{props.item.family_name}} </td>
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{props.item.user_create_date}} </td>
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{props.item.user_tier}} </td>
                             <!-- <td> {{props.item.user_status}} </td> -->
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> <v-icon> {{props.item.email_verified_icon}} </v-icon> </td>
                            <td class="text-xl-center">
                                <v-tooltip top eager close-delay=100>
                                    <template  v-slot:activator="{ on }">
                                        <v-icon v-on="on" small class="mr-2" @click="editUserOpen(props.item)" :style="$store.state.textFormatting.main"> edit </v-icon>
                                    </template>
                                    <span :style="$store.state.textFormatting.main">Edit User</span>
                                </v-tooltip>
                                <v-tooltip top eager close-delay=100>
                                    <template  v-slot:activator="{ on }">
                                        <v-icon v-on="on" small class="mr-2" @click="deleteUserOpen(props.item)" :style="$store.state.textFormatting.main"> delete </v-icon>
                                    </template>
                                    <span :style="$store.state.textFormatting.main">Remove User</span>
                                </v-tooltip>
                                <v-tooltip top eager close-delay=100>
                                    <template  v-slot:activator="{ on }">
                                        <v-icon v-on="on" small class="mr-2" @click="changeUserPassword(props.item)" :style="$store.state.textFormatting.main"> lock </v-icon>   
                                    </template>
                                    <span :style="$store.state.textFormatting.main">Change User Password</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-card>
                <br />
                <v-card class="justify-right" :color="msgColor" v-if="showMessage=true">
                    <h3 :style="$store.state.textFormatting.main"> {{ message }} </h3>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout justify-center wrap v-if="unconfirmed_users.length > 0">
            <v-flex xs12 md8 class="px-2 py-2">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title :style="$store.state.textFormatting.headers"> Unconfirmed users for {{this.$store.state.user.organisation}} </v-toolbar-title>
                    <v-progress-circular v-if="loading" indeterminate color="white"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <info>
                        <template slot>
                            Unconfirmed Users
                        </template>
                        <template slot="body">
                            <p> When you create a user, they will first appear in this list. To enable the user, they will have to confirm via a code sent to the email address on the account </p>
                        </template>
                    </info>
                </v-toolbar>
                <v-card>
                    <v-data-table :headers="headersForUsersTable" :items="unconfirmed_users" :key="id"
                            :rows-per-page-items="rowsPerPageItems2" :pagination.sync="pagination2">
                    <template slot="headerCell" slot-scope="props">
                        <v-tooltip top eager>
                        <span slot="activator" :style="$store.state.textFormatting.main">
                            {{ props.header.text }}
                        </span>
                        <span :style="$store.state.textFormatting.main">
                            {{ props.header.ad_text }}
                        </span>
                        </v-tooltip>
                    </template> 
                    <template slot="items" slot-scope="props">
                        <tr>
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{props.item.username}} </td>
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{props.item.email}} </td>
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{props.item.given_name}} </td>
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{props.item.family_name}} </td>
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{props.item.user_create_date}} </td>
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{props.item.user_tier}} </td>
                             <!-- <td> {{props.item.user_status}} </td> -->
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> <v-icon> {{props.item.email_verified_icon}} </v-icon> </td>
                            <td class="text-xl-center">
                                <v-tooltip top eager close-delay=100>
                                    <template  v-slot:activator="{ on }">
                                        <v-icon v-on="on" small class="mr-2" @click="preResendCode(props.item.username)" :style="$store.state.textFormatting.main"> mail </v-icon>
                                    </template>
                                    <span :style="$store.state.textFormatting.main">Resend Confirmation Email</span>
                                </v-tooltip>
                                <v-tooltip top eager close-delay=100>
                                    <template  v-slot:activator="{ on }">
                                        <v-icon v-on="on" small class="mr-2" @click="deleteUserOpen(props.item)" :style="$store.state.textFormatting.main"> delete </v-icon>
                                    </template>
                                    <span :style="$store.state.textFormatting.main">Remove User</span>
                                </v-tooltip>
                                
                                <!--<v-icon small class="mr-2" @click="changeUserPassword(props.item)" :style="$store.state.textFormatting.main"> lock </v-icon>-->
                            </td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout justify-center wrap>
            <v-flex xs12 md8  v-if="editUserShow" class="py-2 px-2">
                <v-toolbar color="secondary" dark>
                   <v-toolbar-title :style="$store.state.textFormatting.headers"> {{form.username}}: {{ preSubTier }}  </v-toolbar-title> <v-spacer></v-spacer> <v-icon :style="$store.state.textFormatting.main">edit</v-icon> 
                </v-toolbar>
                <v-card >
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container grid-list-xl>
                            <v-layout row wrap>
                            <v-flex md6 xs12>
                                <v-text-field :style="$store.state.textFormatting.main" v-model="form.attributes.given_name" :counter="32" :rules="nameRules" label="Given Name" required></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                                <v-text-field :style="$store.state.textFormatting.main" v-model="form.attributes.family_name" :counter="32" :rules="nameRules" label="Family Name " required></v-text-field>
                            </v-flex>
                            <v-flex md9 xs12>
                                <v-text-field :style="$store.state.textFormatting.main" v-model="form.attributes.email" :counter="64" :rules="emailRules" label="Email Address" ></v-text-field>
                            </v-flex>
                            <v-flex md3 xs12>
                                <v-select :style="$store.state.textFormatting.main" v-model="form.attributes.user_tier" :items="items" label="User Tier" ></v-select>
                            </v-flex>

                            <v-flex md12 xs12 v-if="allowuser">
                                <v-text-field :style="$store.state.textFormatting.main" v-model="form.attributes.locale" label="Organisation" required></v-text-field>
                            </v-flex>
                            <v-card-actions>
                                <v-layout wap >
                                    <v-flex xs12>
                                        <v-btn :style="$store.state.textFormatting.main" color="success" @click="editUser(form)"> Submit </v-btn>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-btn :style="$store.state.textFormatting.main" color="red" @click="editUserShow = !editUserShow" dark> Close </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-actions>
                            
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card>
            </v-flex>
            <v-flex xs12 md8  v-if="changePassword" class="py-2 px-2">
                <v-toolbar color="secondary" dark>
                   <v-toolbar-title :style="$store.state.textFormatting.headers"> Change password for {{PasswordForm.username}} </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                </v-toolbar>
                <v-card >
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container grid-list-xl>
                            <v-layout row wrap>
                                <v-flex xl6>
                            <v-text-field label="Password" :rules="passwordRules" v-model="PasswordForm.first" min="8" :append-icon="e1 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e1 = !e1)"
                                :type="e1 ? 'password' : 'text'" required :style="$store.state.textFormatting.main"></v-text-field>
                                </v-flex>
                                <v-flex xl6>
                            <v-text-field label="Repeat Password" :rules="passwordRules" v-model="PasswordForm.second" min="8" :append-icon="e1 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e1 = !e1)"
                                :type="e1 ? 'password' : 'text'" required :style="$store.state.textFormatting.main"></v-text-field>
                                </v-flex>
                                <v-flex xs12 v-if="wrongPasswordMessage">
                                    <h3 color="red" :style="$store.state.textFormatting.main"> {{wrongPasswordMessage}} </h3>
                                </v-flex>
                            <v-card-actions>
                                <v-layout align-right justify-right>
                                    <v-flex>
                                        <v-btn color="red" @click="changePassword = false" dark :style="$store.state.textFormatting.main"> Close </v-btn>
                                    </v-flex>
                                    <v-flex>
                                        <v-spacer />
                                    </v-flex>
                                    <v-flex>
                                        <v-btn color="success" @click="submitChangePassword(PasswordForm)" :style="$store.state.textFormatting.main"> Submit </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-actions>
                            
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card>
            </v-flex>
            <v-dialog v-model="showAreYouSure" :width="this.$store.state.textFormatting.dialog.width">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title :style="$store.state.textFormatting.headers"> {{form.username}}: {{form.attributes.user_tier}} </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                </v-toolbar>
                <v-card >
                    <v-card-text>
                        <h3 :style="$store.state.textFormatting.main"> Are you sure you want to delete {{form.attributes.given_name}} {{form.attributes.family_name}}?</h3>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="green" dark @click="deleteUser(form)" :style="$store.state.textFormatting.main"> Yes, delete</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="red" dark @click="showAreYouSure=false" :style="$store.state.textFormatting.main"> No, close </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="showResend" :width="this.$store.state.textFormatting.dialog.width">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title :style="$store.state.textFormatting.headers"> Resend Authentication code for {{ resendStage }} </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                </v-toolbar>
                <v-card >
                    <v-card-text>
                        <h3 :style="$store.state.textFormatting.main"> Resend Authentication code for {{ resendStage }}?</h3>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="green" dark @click="resendAuthCode" :style="$store.state.textFormatting.main"> Yes, send</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="red" dark @click="showResend=false" :style="$store.state.textFormatting.main"> No, close </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-flex xs12 md8 v-if="showAddUser" class="py-2 px-2">
                <adduser v-on:newUserAdded="NewUserAddedInChild" v-on:closeWindow="showAddUser=false"></adduser>
            </v-flex>
            
        </v-layout>
      </v-container>
</template>

<script>

import { API, graphqlOperation } from 'aws-amplify';
import { Auth } from 'aws-amplify'
import adduser from '../../components/settings/AddUser'
import changepassword from '../developing/change-password'
import info from '../operational/infopopout.vue'

export default {
    name: "user-admin",
    components: {
        adduser,
        changepassword,
        info
    },
    data () {
        return {
            items: ['Admin', 'Developer', 'Analyst' ],
            form: {"username": 'TestUserFromUI11', "password": '', attributes: {
                "email": 'nicholas.layton@bt.com', "given_name": "Nicholas", "family_name": "Layton", "locale": "BTGlobal", "user_tier": "Admin"
                }
            },
            username: "NewUser",
            password: "password",
            preSubTier: "",
            UsersInTableForGroup: [],
            headersForUsersTable: [
                { text: 'Username', values: 'username', align:'centre', ad_text: 'Username on the account (unique across the whole system)'},
                { text: 'Email', value:'email', align:'centre', ad_text: 'Email address associated with the account, please only create one account per email address or errors may occur'},
                { text: 'Given Name', value:'given_name', align:'centre', ad_text: 'First name'},
                { text: 'Family Name', value:'family_name', align:'centre', ad_text: 'Second (family) name'},
                { text: 'Date Created', value: 'user_create_date', align:'centre', ad_text: 'Date account was created'},
                { text: 'User Type', value: 'user_tier', align:'centre', ad_text: 'Admin/ Developer/ Analyst'},
                // { text: 'User Status', value:'user_status', sortable: false },
                { text: 'Email verified', value: "email_verified", align:'centre', ad_text: 'Has this user verified '},
                { text: 'Actions', value: "actions", sortable: false, align:'centre'}
            ],
            editUserShow: false,
            deleteUserShow: false,
            showMessage: false,
            dialog:false,
            overlay: false,
            loading: true,
            message: null,
            msgColor: 'success',
            displayMessage: false,
            showAreYouSure: false,
            showAddUser: false,
            changePassword: false,
            wrongPasswordMessage: null,
            id: null,
            rowsPerPageItems: [20, 30, 40, 50],
            pagination: {
                rowsPerPage: 20
            },
            rowsPerPageItems2: [20, 30, 40, 50],
            pagination2: {
                rowsPerPage: 20
            },
            PasswordForm: {"username": "", "first": null, "second": null},
            emailRules: [ v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail must be valid' ],
            passwordRules: [ v => !!v || 'A valid Password is required', v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$/.test(v) || 'Password must be over 8 characters long and contain 1 uppercase, 1 lowercase, 1 special char (@$!%*?&_) and 1 number'],
            nameRules: [ v=> !!v || 'Name required', v => /^[a-zA-Z]+$/.test(v) || 'Name must be valid' ],
            unconfirmed_users: [],
            resendStage: null,
            showResend: false,
        
        }
    },
    mounted() {
        //this.returnUsersForOrganisation()
        this.getAllUsersForGroup()
        try {
            this.organisation = this.$store.state.user.organisation;
        } catch (err) {
            console.log(err)
            location.reload()
        }
    },
    methods: {
        submitChangePassword: async function (form) {
            if (this.$refs.form.validate()) {
                if(form.first ==form.second) {
                    console.log("QUERY")
                    let USERPOOL = await Auth.currentUserPoolUser()
                    var cognito_pool = USERPOOL.pool.userPoolId
                    var query = `mutation test {
                                    editUserPassword (
                                        username: "`+form.username+`", 
                                        pool: "`+cognito_pool+`", 
                                        password: "`+form.first+`", 
                                        perm: true )
                                    }`
                    try {
                      const changePassword = await API.graphql(graphqlOperation(query))
                        this.message = changePassword.data.editUserPassword
                        if (this.message.includes('Success')) {
                            this.msgColor = 'success';
                        } else {
                            this.msgColor = 'red';
                        }
                        this.changePassword = false
                        this.PasswordForm = {"username": "", "first": null, "second": null}
                    } catch (err) {
                        console.log(err)
                    }
                    
                    
                } else {
                    this.wrongPasswordMessage = "Passwords don't match"
                }
                
            }
            this.showMessage = true;
        },
        changeUserPassword: function (user) {
            this.showMessage = false;
            this.changePassword = true
            this.showAddUser = false
            this.editUserShow= false
            this.showAreYouSure =false
            this.PasswordForm = {"username": user.username, "first": null, "second": null}
            window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
            this.$nextTick(() => {
                // Add the component back in
                window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
            });
        },
        NewUserAddedInChild: function () {
            //this.returnUsersForOrganisation()
            this.getAllUsersForGroup()
            this.message="Success, a user has been created (they appear in the unconfirmed list until they have confirmed via email)"
            this.showAddUser = false;
            this.showMessage = true;
        },
        addUserOpen: function() {
            this.showMessage = false;
            this.changePassword = false
            this.showAddUser = true
            this.editUserShow= false
            this.showAreYouSure =false
        },
        deleteUserOpen: function (user) {
            this.showMessage = false;
            this.changePassword = false
            this.showAreYouSure = true
            this.editUserShow= false
            this.showAddUser = false
            this.form = {"username": user.username, attributes: {
                "email": user.email, "given_name": user.given_name, "family_name": user.family_name, "name": user.user_tier
                }
            }
        },
        editUserOpen: function (user) {
            console.log(user);
            this.showMessage = false;
            
            this.changePassword = false
            this.editUserShow= true
            this.showAreYouSure =false
            this.showAddUser = false
            this.form = {"username": user.username, attributes: {
            "email": user.email, "given_name": user.given_name, "family_name": user.family_name, "user_tier": user.user_tier
                }
            }
            this.preSubTier = this.form.attributes.user_tier;
            window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
            this.$nextTick(() => {
                // Add the component back in
                window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
            });
        },
        preResendCode: async function (user) {
            this.resendStage = user
            this.showResend = true
        },
        resendAuthCode: async function () {
            var resend_user = this.resendStage
            try {
                const signup = await Auth.resendSignUp(resend_user);
                this.message = "Code has been resent for " + resend_user
                this.showResend = false
            } catch(err){
                this.message = (err.message)
                console.log(err)
                this.showResend = false
            }
        },
        returnUsersForOrganisation: async function () {
            this.loading = true;
            var organisation = this.$store.state.user.organisation
            let USERPOOL = await Auth.currentUserPoolUser()
            var cognito_pool = USERPOOL.pool.userPoolId
            
            var query = `query getUsersForGroup { getUsersForGroup(group: "`+organisation+`", pool: "`+cognito_pool+`") {
                    username
                    email_verified
                    user_tier
                    given_name
                    family_name
                    email
                    user_create_date
                    user_last_modified_date
                    enabled
                    user_status
                }
            }`
             const UsersForGroup = await API.graphql(graphqlOperation(query));
             console.log(UsersForGroup)
             var UsersForGroupUnwrap = UsersForGroup.data.getUsersForGroup
             console.log(UsersForGroupUnwrap)

             for (var i = 0; i< UsersForGroupUnwrap.length; i = i +1) {
                 UsersForGroupUnwrap[i].user_create_date= UsersForGroupUnwrap[i].user_create_date.split('T')[0]
                 if ( UsersForGroupUnwrap[i].email_verified == "true") {
                     UsersForGroupUnwrap[i].email_verified_icon = "check"
                 } else if ( UsersForGroupUnwrap[i].email_verified == "false") {
                     UsersForGroupUnwrap[i].email_verified_icon = "clear"
                 }
             }
             console.log(UsersForGroupUnwrap)

             this.UsersInTableForGroup = UsersForGroupUnwrap
             this.loading = false;
        },
        getAllUsersForGroup: async function () {
            this.loading = true;
            var organisation = this.$store.state.user.organisation
            let USERPOOL = await Auth.currentUserPoolUser()
            console.log(USERPOOL)
            var cognito_pool = USERPOOL.pool.userPoolId
            var token;
            this.UsersInTableForGroup = []
            this.unconfirmed_users = []

            while (true) {
                if (!token) {
                    token = '';
                }
                var query = `query getUsersForGroup2 { getUsersForGroup2 (group: "`+organisation+`", pool: "`+cognito_pool+`", token: "` + token + `") {
                                    username
                                    email_verified
                                    user_tier
                                    given_name
                                    family_name
                                    email
                                    user_create_date
                                    user_last_modified_date
                                    enabled
                                    user_status
                                }
                }`
                console.log(query)
                const UsersForGroup = await API.graphql(graphqlOperation(query));

                console.log(UsersForGroup)
                var UsersForGroupUnwrap = UsersForGroup.data.getUsersForGroup2
                console.log(UsersForGroupUnwrap)
                for (var i = 0; i< UsersForGroupUnwrap.length; i = i +1) {
                    if (UsersForGroupUnwrap[i].username == "NON-USER") {
                        token = UsersForGroupUnwrap[i].given_name;
                        continue;
                    }
                    UsersForGroupUnwrap[i].user_create_date= UsersForGroupUnwrap[i].user_create_date.split('T')[0]
                    if ( UsersForGroupUnwrap[i].email_verified == "true") {
                        UsersForGroupUnwrap[i].email_verified_icon = "check"
                    } else if ( UsersForGroupUnwrap[i].email_verified == "false") {
                        UsersForGroupUnwrap[i].email_verified_icon = "clear"
                    }
                    if ( UsersForGroupUnwrap[i].user_status == 'CONFIRMED' ) {
                        this.UsersInTableForGroup.push(UsersForGroupUnwrap[i])
                    } else {
                        this.unconfirmed_users.push(UsersForGroupUnwrap[i])
                    }
                }
                //console.log(UsersForGroupUnwrap)
                if (token) {
                    if (!(token == '')) {
                        console.log("contuining: " + token.toString())
                        continue;
                    } else {
                        this.loading = false;
                        console.log("breaking: " + token.toString())
                        break;
                    }
                } else {
                    console.log("breaking: no token")
                    this.loading = false;
                    break;
                }
            }
        },
        editUser: async function (userInfo) {
            let USERPOOL = await Auth.currentUserPoolUser()
            var cognito_pool = USERPOOL.pool.userPoolId

            var query = `mutation editUser {
                            editUser (
                                username: "`+userInfo.username+`", 
                                pool: "`+cognito_pool+`", 
                                usertier:"`+userInfo.attributes.user_tier+`",
                                given_name: "`+userInfo.attributes.given_name+`", 
                                family_name: "`+userInfo.attributes.family_name+`", 
                                email: "`+userInfo.attributes.email+`",
                                pretier: "` + this.preSubTier + `")
                            }`
            console.log(query)
            const updateAttributes = await API.graphql(graphqlOperation(query))
            this.message=updateAttributes.data.editUser
            console.log(updateAttributes.data.editUser)
            //this.returnUsersForOrganisation()
            this.getAllUsersForGroup()
            this.editUserShow = false;
            if (this.message.includes('Success')) {
                this.msgColor = 'success';
            } else {
                this.msgColor = 'red';
            }
            this.showMessage = true;
        },
        deleteUser: async function (user) {
            let USERPOOL = await Auth.currentUserPoolUser()
            var cognito_pool = USERPOOL.pool.userPoolId
            
            this.deleteUserShow = true
            var query = `mutation deleteUser {
                            deleteUser(
                                username: "`+user.username+`", 
                                pool: "`+cognito_pool+`")
                            }`
            const deleteUser = await API.graphql(graphqlOperation(query))
            this.message=deleteUser.data.deleteUser
            
            //this.returnUsersForOrganisation()
            this.getAllUsersForGroup()
            this.showAreYouSure = false;
            this.showMessage = true;
        }
        

    }
}
</script>

<style scoped>

    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }

    .v-table tr:hover:not(.v-table__expanded__content) {
        background-color: rgba(0, 0, 0, .4);
    }

</style>